import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../../core/services/navigation.service';
import { NavigationData } from '../../../core/interfaces/navigation.interface';

@Component({
  selector: 'app-navbar-style-two',
  templateUrl: './navbar-style-two.component.html',
  styleUrls: ['./navbar-style-two.component.scss']
})
export class NavbarStyleTwoComponent implements OnInit {
  navigationData: NavigationData | null = null;
  isNavbarOpen: boolean;

  constructor(private navigationService: NavigationService) { }

  ngOnInit(): void {
    this.loadNavigationData();
  }

  private loadNavigationData(): void {
    this.navigationService.getMainMenu().subscribe({
      next: (data:any) => {
        this.navigationData = data;
        console.log(this.navigationData);
      },
      error: (error) => {
        console.error('Error loading navigation data:', error);
      }
    });
  }


   toggleNavbar() {
      this.isNavbarOpen = !this.isNavbarOpen;
   }

   closeNavbar() {
     this.isNavbarOpen = false;
   }

   refreshPage(link: string): void {
    window.location.href = link; 
   }


}
